export default "__VITE_ASSET__DlUNLnwW__"